import ChatView from "@/components/ChatView";
export default function PortalChat() { return <ChatView origin="portal"/>; }
